export default "__VITE_ASSET__Wm4eee8K__"